// Wayfinding semantics shared across every template so users get the
// same mental model regardless of which template they're looking at.
//
//  - hasNextSlide  → drives whether "next" arrow / pill renders
//  - shouldShowCounter → drives counter visibility (body slides only)
//  - formatPageLabel → canonical "02/05" page-counter string
//
// Conventions:
//  - The cover is page 1 of the deck (so first body slide reads 02/MM).
//  - Counters are body-only - cover is implicit page 1, no need to label it.
//  - Single-card carousels show nothing (no arrow, no counter).
//  - The arrow hides on the final slide so the user knows it's the end;
//    the counter stays so they still know their position.

export function hasNextSlide(slideIndex: number, totalSlides: number): boolean {
  return totalSlides > 1 && slideIndex < totalSlides - 1;
}

export function shouldShowCounter(
  slideIndex: number,
  totalSlides: number
): boolean {
  return totalSlides > 1 && slideIndex > 0;
}

export function formatPageLabel(
  slideIndex: number,
  totalSlides: number
): string {
  const page = String(slideIndex + 1).padStart(2, '0');
  const total = String(totalSlides).padStart(2, '0');
  return `${page}/${total}`;
}
